export default __webpack_public_path__ + "static/media/icon_CME.324f69e9.svg";